import $ from 'jquery'

// Add this behaviour to a <select> tag to turn the options into "links"
$(document).on('change', "[data-behaviour~='select-navigate']", function () {
  const url = $(this).val()
  redirectToSelectUrl(this, url)
})

$(document).on(
  'click',
  "[data-behaviour~='submit-select-navigate']",
  function (event) {
    const $selected = $(this).parents('form').find('select option:selected')
    const url = $selected.val()

    const $optionalNameInput = $(this)
      .parents('form')
      .find('[data-behavior~="data-name-input"] input')
    const $mandatoryNameInput = $(this)
      .parents('form')
      .find('[data-behavior~="data-name-input-mandatory"] input')

    $optionalNameInput.val($optionalNameInput.val().trim())
    $mandatoryNameInput.val($mandatoryNameInput.val().trim())

    if ($mandatoryNameInput.is(':visible') && !$mandatoryNameInput.val()) {
      event.preventDefault()
      window.sfAlert({
        message: I18n.t('sync_entities.new_modal.js.name_is_mandatory'),
      })
      return
    }

    if ($selected.data('submit-method') === 'POST') {
      const $form = $selected.parents('form')

      $form.attr('action', url)
      $form.submit()
    } else {
      // the point of adding this parameters is to make it available
      // in the Oauth controller, as part of the sync entity creation
      // since this is transforming the POST form into a GET request
      let newSyncEntityName
      if ($mandatoryNameInput.is(':visible')) {
        newSyncEntityName = $mandatoryNameInput.val()
      } else {
        newSyncEntityName = $optionalNameInput.val()
      }

      const params = !newSyncEntityName
        ? ''
        : '?sync_entity_name=' + newSyncEntityName

      redirectToSelectUrl(this, url + params)
    }
  }
)

function redirectToSelectUrl(trigger, url) {
  const turboDisabled =
    $(trigger).parent("[data-turbolinks='false']").length > 0
  if (window.Turbolinks && !turboDisabled) {
    window.Turbolinks.visit(url)
  } else {
    window.location.href = url
  }
}
